<template>
  <div>
    <b-row v-if="activity.status != 'COMPLETED' && activity.status != 'REJECTED' && activity.status != 'CANCELLED'">
      <b-form-group
        id="input-training-leader"
        :label="$t('training-view.addLeader')"
        label-for="input-leader"
        label-align="left"
        class="col-4"
      >
<!--        <v-select-->
<!--          v-if="availableTrainers != null"-->
<!--          :options="availableTrainers"-->
<!--          placeholder=""-->
<!--          :clearable='true'-->
<!--          v-model="trainerDenied"-->
<!--          class="bg-white rounded"-->
<!--        >-->
<!--          <template #no-options="{ }">-->
<!--            {{ $t("training-add.noTrainers") }}-->
<!--          </template>-->
<!--        </v-select>-->


        <v-select
            v-if="availableTrainers != null"
            :options="availableTrainers"
            placeholder=""
            :clearable='true'
            v-model="trainerDenied.member"
            class="bg-white rounded"
        >
       </v-select>

      </b-form-group>
      <b-form-group
        id="input-item-denial-reason"
        :label="$t('training-view.denialReason')"
        label-for="input-denial-reason"
        label-align="left"
        class="col-lg-6 col-md-5"
      >
       <b-form-input
          id="input-denial-reason"
          type="text"
          v-model="denialReason"
          placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-button variant="primary" class="esep-blue-bg col-lg-1 col-md-2 h-50 my-auto" @click="addDenial()">
          {{ $t("common.add")}}</b-button>
      <hr/>
    </b-row>
    
    <b-table 
      :items="denials"
      :fields="fields"
      responsive
      show-empty
      thead-class="esep-blue-bg text-light"
    > 
      <template v-slot:cell(action)="row">
        <b-button
          size="sm"
          @click="deleteDenial(row)"
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('training-view.deleteDenial')"
        >
          <b-icon icon="trash"></b-icon>
        </b-button>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t("training-view.emptyDenialsTable") }}</h6>
      </template>

    </b-table>
  </div>
</template>

<script>
import trainingService from "../../services/training.service";
import {handleApiError} from "../../services/error.service";

export default {
  props: {
    activity: Object
  },
  mounted() {
    this.getTrainersByBranch();
    this.getLeaderDenials();
  },
  data() {
    return {
      availableTrainers: null,
      trainerDenied: {
        id: null
      },
      denialReason: null,
      fields: [
        { key: "member.id", label: "Α.Μ.", sortable: false, thClass: 'text-left', tdClass: 'text-left'},
        { key: "member", label: "Ονοματεπώνυμο", sortable: false , formatter: "formatFullName", thClass: 'text-left', tdClass: 'text-left'},
        { key: "comments", label: "Σχόλια", sortable: false, thClass: 'text-left', tdClass: 'text-left' },
        { key: "action", label: "Ενέργεια", sortable: false  }
      ],
      denials: null
    }
  },
  methods: {
    addDenial() {
      trainingService.addLeaderDenial(this.activity, this.denialReason, this.trainerDenied.member.member.id).then(
        () => {
          this.denialReason = null;
          this.trainerDenied = {id: null};
          this.getLeaderDenials();
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    deleteDenial(row) {
      trainingService.updateDenialStatus(row.item.id, 'CANCELLED').then(
        () => {
          this.getLeaderDenials();
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    getTrainersByBranch() {
      trainingService.getTrainersByBranch(this.activity.module.branch).then(
        (response) => {
          this.availableTrainers =  response.data;
          this.availableTrainers.map(function(e){
            e.label = `${e.member.surName} ${e.member.firstName} (${e.member.id})`;
          });
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    formatFullName(member) {
      return member.surName +" " + member.firstName;
    },
    getLeaderDenials() {
      trainingService.getLeaderDenials(this.activity.id).then(
        (response) => {
          this.denials = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    }
  }
}
</script>

<style>

</style>